import { useMainStore } from "@/composables/store";
import { resolveInitialPreference } from "@/utils/localeCurrencyPreference";

export default defineNuxtPlugin((nuxtApp) => {
  const store = useMainStore();
  const savedCurrency = window.localStorage.getItem("currentCurrency");
  const currencySource = window.localStorage.getItem("currentCurrencySource");
  let savedCurrencyItem = null;
  try { savedCurrencyItem = JSON.parse(savedCurrency || "null"); }
  catch {}
  const savedCurrencyCode = String(savedCurrencyItem?.toCurrencyCode || "").toUpperCase();
  const legacyFallbackCurrency = !currencySource && savedCurrencyCode === "CNY" && savedCurrencyItem?.id === "CNY";
  const hadLocalCurrency = Boolean(savedCurrencyCode) && currencySource !== "AUTO" &&
    !legacyFallbackCurrency;
  let activeInitialization = null;

  const initializeLocaleCurrency = async () => {
    if (activeInitialization) return activeInitialization;
    activeInitialization = (async () => {
      store.localeCurrencyError = false;
      try {
        let rateError;
        for (let attempt = 0; attempt < 2; attempt += 1) {
          try {
            await store.getCurrencyData();
            rateError = null;
            break;
          } catch (error) {
            rateError = error;
            if (attempt === 0) await new Promise(resolve => setTimeout(resolve, 300));
          }
        }
        if (rateError) {
          console.warn("汇率加载失败，使用已选币种或店铺默认币种:", rateError);
        }

        const i18n = nuxtApp.$i18n;
        const result = await resolveInitialPreference(store, {
          value: i18n.locale.value,
          set: (value) => i18n.setLocale(value),
        }, hadLocalCurrency || store.accountCurrencyApplied);
        window.localStorage.setItem("i18n_current_locale", result.locale);
        i18n.setLocaleCookie?.(result.locale);
        store.localeCurrencyReady = true;
        if (rateError) {
          const retryTimer = setTimeout(() => {
            store.getCurrencyData().catch(error => console.warn("汇率重试失败:", error));
          }, 3000);
          retryTimer.unref?.();
        }
      } catch (error) {
        console.warn("语种币种初始化失败:", error);
        store.localeCurrencyError = true;
      }
    })();
    try {
      await activeInitialization;
    } finally {
      activeInitialization = null;
    }
  };

  nuxtApp.provide("retryLocaleCurrency", initializeLocaleCurrency);
  nuxtApp.hook("app:mounted", initializeLocaleCurrency);
});
